// src/App.js
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import {AppProviders} from "./Providers";
import { useUser } from './contexts/UserProvider';
import HomePage from "./pages/HomePage";
import RequestAttire from "./pages/RequestAttire";
import NotFoundPage from "./pages/NotFoundPage";
import TermsAndConditions from "./pages/TermsAndConditionPage";
import SignUp from "./pages/SignUp";
import Login from "./pages/Login";
import MyBookings from "./pages/MyBookings";
import Profile from "./pages/Profile";
import AllAppointments from './pages/AllAppointments';
import PrivacyPolicy from "./pages/PrivacyPolicyPage";
import RequestDeletion from "./pages/RequestDeletion";
import AppointmentPaymentCallbackScreen from "./pages/AppointmentPaymentCallbackScreen";

// Store Components
import { StoreProvider } from './contexts/StoreProvider';
import StoreLayout from './pages/store/StoreLayout';
import StoreScreen from './pages/store/StoreScreen';
import ProductDetailScreen from './pages/store/ProductDetailScreen';
import CartScreen from './pages/store/CartScreen';
import CheckoutScreen from './pages/store/CheckoutScreen';
import PaymentCallbackScreen from './pages/store/PaymentCallbackScreen';
import OrderHistoryScreen from './pages/store/OrderHistoryScreen';
import OrderDetailScreen from './pages/store/OrderDetailScreen';
import FavoritesScreen from './pages/store/FavoritesScreen';

alertify.set('notifier', 'position', 'top-right');
alertify.set('notifier', 'delay', 5);

function App() {

  return (
    <MainApp />
  );
}

function MainApp() {



  return (
    <StoreProvider>
      <Router>
        <Routes>
        {/* <Route path="/" element={<LandingPage />} /> */}
        <Route path="/" element={<HomePage />} />

        <Route path="/bookings" element={<RequestAttire />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/all-appointments" element={<AllAppointments />} />
        <Route path="/appointment-payment-status" element={<AppointmentPaymentCallbackScreen />} />

        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/sign-up" element={<SignUp />} />

        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/request-deletion" element={<RequestDeletion />} />

        {/* Store Routes */}
        <Route path="/store" element={<StoreLayout />}>
          <Route index element={<StoreScreen />} />
          <Route path="product/:id" element={<ProductDetailScreen />} />
          <Route path="cart" element={<CartScreen />} />
          <Route path="checkout" element={<CheckoutScreen />} />
          <Route path="payment-status" element={<PaymentCallbackScreen />} />
          <Route path="orders" element={<OrderHistoryScreen />} />
          <Route path="orders/:id" element={<OrderDetailScreen />} />
          <Route path="favorites" element={<FavoritesScreen />} />
        </Route>

        {/* page not found route should be the last route */}
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </Router>
    </StoreProvider>
  )
}

export default App;